export default "__VITE_ASSET__SIhhGwq3__"